import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {NavLink} from "react-router-dom";

const { Title, Paragraph } = Typography;

const books = [
    {
        id: 1,
        title: "React: Up & Running",
        author: "Стоян Стефанов",
        description: "Создавайте динамичные веб-приложения с помощью React",
        image: "https://images.manning.com/book/c/e237742-87f3-486d-b863-98fb6de89e60/Garreau-Redux-HI.png",
        price: "2500 ₽"
    },
    {
        id: 2,
        title: "Полное руководство по современному веб-программированию",
        author: "Робин Никсон",
        description: "Всестороннее руководство по HTML, CSS, JavaScript и PHP",
        image: "https://cdn1.ozone.ru/s3/multimedia-g/c600/6625769668.jpg",
        price: "3000 ₽"
    },
    {
        id: 3,
        title: "React и Redux в действии",
        author: "Марк Тилен Уэбер",
        description: "Разработка веб-приложений с использованием React и Redux",
        image: "https://static.insales-cdn.com/images/products/1/1718/184600246/44610999.jpg",
        price: "2800 ₽"
    }
];

const ShopCom = () => {
    return (
        <Container maxWidth="lg">
            <div style={{margin: 10}}>
                <NavLink to={'/'}>
                    <Button>
                        Назад
                    </Button>
                </NavLink>
            </div>
            <Box my={4}>
                <Title level={2}>Магазин книг по веб-разработке</Title>
                <h2>Книги по react и веб-разработке</h2>
                <Row gutter={[16, 16]}>
                    {books.map((book) => (
                        <Col key={book.id} xs={24} sm={12} md={8}>
                            <Card
                                hoverable
                                cover={<img alt={book.title} src={book.image}/>}
                            >
                                <Title level={4}>{book.title}</Title>
                                <Paragraph>Автор: {book.author}</Paragraph>
                                <Paragraph>{book.description}</Paragraph>
                                <Paragraph strong>{book.price}</Paragraph>
                                <Button variant="contained" color="primary">
                                    Добавить в корзину
                                </Button>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Box>
            <Box mt={4} textAlign="center">
                <Paragraph italic>
                    Эта страница создана для учебного проекта. Мы ничего не продаем.
                </Paragraph>
            </Box>
        </Container>
    );
};

export default ShopCom;
